import LogoFull from '@core/assets/logo.svg?react';
import LogoCompact from '@core/assets/logo2.svg?react';
import PropTypes from 'prop-types';

/**
 * Logo Component
 *
 * Displays DolmaHR logo as an SVG React component with dynamic colors.
 * When a custom `src` URL is provided and the variant is 'full', renders an <img> instead.
 *
 * @param {Object} props
 * @param {string} [props.className='h-6 w-auto'] - Tailwind classes for sizing and styling
 * @param {string} [props.variant='full'] - Logo variant ('full' or 'compact')
 * @param {string} [props.src] - Optional custom logo URL (only used with 'full' variant)
 */
export function Logo({ className = 'h-6 w-auto', variant = 'full', src }) {
  if (src && variant === 'full') {
    return <img src={src} alt="Logo" className={className} />;
  }

  const LogoComponent = variant === 'compact' ? LogoCompact : LogoFull;

  return (
    <LogoComponent
      className={className}
      aria-label="DolmaHR"
    />
  );
}

Logo.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['full', 'compact']),
  src: PropTypes.string,
};
